import React, { useState } from "react";
import {
  DatetimePicker,
  FormGroup,
  FormGroupVerticalInput,
  LabelForm,
  RadioInput,
} from "../../components";
import { hasErrorInput, getInputErrorMessage } from "../../utils";

const SearchDateTime = ({
  dataSearch,
  setDataSearch,
  supportValues,
  setSupportValues,
  errors,
}) => {
  const handleChangeFormData = (fieldName, value) => {
    setDataSearch((preFormData) => ({
      ...preFormData,
      [fieldName]: value,
    }));
  };

  const handleDatetimeData = (dateRanger) => {
    let endDatetime = new Date();
    let startDatetime = new Date();
    switch (dateRanger) {
      case "today":
        startDatetime.setHours(0, 0, 0, 0);
        endDatetime.setHours(23, 59, 59, 999);
        break;
      case "this_month":
        startDatetime = new Date(
          endDatetime.getFullYear(),
          endDatetime.getMonth(),
          1
        );
        endDatetime = new Date(
          endDatetime.getFullYear(),
          endDatetime.getMonth() + 1,
          0
        );
        endDatetime.setHours(23, 59, 59, 999);
        break;
      case "last_month":
        startDatetime = new Date(
          endDatetime.getFullYear(),
          endDatetime.getMonth() - 1,
          1
        );
        endDatetime = new Date(
          endDatetime.getFullYear(),
          endDatetime.getMonth(),
          0
        );
        endDatetime.setHours(23, 59, 59, 999);
        break;
      case "last_31_days":
        startDatetime = new Date(endDatetime);
        startDatetime.setDate(startDatetime.getDate() - 31);
        break;
      case "past_year":
        startDatetime = new Date(endDatetime);
        startDatetime.setFullYear(startDatetime.getFullYear() - 1);
        break;
      default:
    }
    setDataSearch({
      ...dataSearch,
      start_datetime: startDatetime,
      end_datetime: endDatetime,
    });
    setSupportValues({
      ...supportValues,
      date_ranger: dateRanger,
      disabled: false,
    });
  };

  return (
    <>
      <FormGroup direction="horizontal">
        <LabelForm
          text="点検日"
          className="lg:min-w-[248px] min-w-[232px]"
        />
        <FormGroupVerticalInput>
          <div className="flex flex-row items-center space-x-5">
            <RadioInput
              id="today"
              name="inspection_date"
              value="today"
              label="本日"
              onChange={(e) => handleDatetimeData(e.target.value)}
              checked={supportValues.date_ranger === "today"}
            />
            <RadioInput
              id="this_month"
              name="inspection_date"
              value="this_month"
              label="今月"
              onChange={(e) => handleDatetimeData(e.target.value)}
              checked={supportValues.date_ranger === "this_month"}
            />
            <RadioInput
              id="last_month"
              name="inspection_date"
              value="last_month"
              label="先月"
              onChange={(e) => handleDatetimeData(e.target.value)}
              checked={supportValues.date_ranger === "last_month"}
            />
            <RadioInput
              id="last_31_days"
              name="inspection_date"
              value="last_31_days"
              label="過去31日間"
              onChange={(e) => handleDatetimeData(e.target.value)}
              checked={supportValues.date_ranger === "last_31_days"}
            />
            <RadioInput
              id="past_year"
              name="inspection_date"
              value="past_year"
              label="過去1年間"
              onChange={(e) => handleDatetimeData(e.target.value)}
              checked={supportValues.date_ranger === "past_year"}
            />
          </div>
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup direction="vertical">
        <FormGroupVerticalInput
          className="lg:ml-[248px] ml-[232px]"
          error={getInputErrorMessage(errors, "start_datetime")}
        >
          <FormGroupVerticalInput
            className=""
            error={getInputErrorMessage(errors, "end_datetime")}
          >
            <div className="flex flex-row">
              <DatetimePicker
                id="start_datetime"
                name="start_datetime"
                timeFormat={true}
                hasError={hasErrorInput(errors, "start_datetime")}
                className="tenken__text-gray-900 xl:w-[200px] w-[180px]"
                onChange={handleChangeFormData}
                value={dataSearch.start_datetime}
                maxLength="15"
                showClearButton={true}
                disabled={supportValues.disabled}
              />
              <span className="2xl:text-[26px] xl:text-[22px] md:text-[22px] mx-[13px]">
                ~
              </span>
              <DatetimePicker
                id="end_datetime"
                name="end_datetime"
                timeFormat={true}
                hasError={hasErrorInput(errors, "end_datetime")}
                className="tenken__text-gray-900 xl:w-[200px] w-[180px]"
                onChange={handleChangeFormData}
                value={dataSearch.end_datetime}
                maxLength="15"
                showClearButton={true}
                disabled={supportValues.disabled}
              />
            </div>
          </FormGroupVerticalInput>
        </FormGroupVerticalInput>
      </FormGroup>
    </>
  );
};

export default SearchDateTime;
